import React from 'react';
import styled from 'styled-components';
import {Subheading} from 'app/styles/heading';
import {COLORS, ELEVATIONS, SIZES} from '@fupa/fupa-uikit';
import {PlayerSeason} from 'app/components/profile/PlayerSeason';
import ProfileRoleStats from 'app/components/profile/ProfileRoleStats';
import {ProfileStationsWithStats} from 'app/components/profile/profile.constants';
import {AdSlot} from 'app/components/ads/AdSlot';

const Container = styled.div`
  background-color: ${COLORS.white};
  box-shadow: ${ELEVATIONS.Card};
  margin-top: ${SIZES['8']};
`;

const Header = styled.div`
  padding-bottom: ${SIZES['16']};
`;

const CustomSubheading = styled(Subheading)`
  &&& {
    margin: 0;
  }
`;

const coachTotalStatisticKeys = {
  matches: 'Spiele',
  wins: 'Siege',
  draws: 'Remis',
  defeats: 'Niederlagen',
  points: 'Punkte',
};

const playerTotalStatisticKeys = {
  matches: 'Spiele',
  goals: 'Tore',
  assists: 'Assists',
  yellowCard: 'Gelb',
  yellowRedCard: 'Gelb-Rot',
  redCard: 'Rot',
  topEleven: 'Elf d. W.',
};

const ProfileStations = ({role, stations, adUnits, ...props}) => {
  const ProfileStations = stations.seasons.map(season => (
    <PlayerSeason key={season.id} station={season} role={role === 'Trainer' ? 'coach' : 'player'} {...props} />
  ));

  const hasTotalStatistics = stations.seasons.find(
    season => ProfileStationsWithStats.indexOf(season.position ?? 'Spieler') >= 0
  );

  const totalStatistics = hasTotalStatistics ? (
    <ProfileRoleStats
      statisticValues={stations.total}
      statisticKeys={role === 'Trainer' ? coachTotalStatisticKeys : playerTotalStatisticKeys}
    />
  ) : null;

  if (adUnits) {
    adUnits.map((adUnit, index) => {
      // 5. Elem, 10.Elem, 15.Elem, 20.Elem
      const spliceAt = index === 0 ? 5 : 5 * (index + 1) + 1;
      if (ProfileStations.length + 1 > spliceAt) {
        ProfileStations.splice(spliceAt, 0, <AdSlot key={adUnit} adUnit={adUnit} />);
      }
    });
  }

  return (
    <Container>
      <Header>
        <CustomSubheading variant='subheading2'>{role}stationen</CustomSubheading>
      </Header>
      {ProfileStations}
      {totalStatistics}
    </Container>
  );
};

export {ProfileStations};
